export function buildSocialMediaSettings(socialSelection = []) {
  if (!Array.isArray(socialSelection)) {
    return {};
  }

  return socialSelection.reduce((acc, item) => {
    if (!item?.name) {
      return acc;
    }
    const key = String(item.name).trim().toLowerCase();
    acc[key] = item.data || {};
    return acc;
  }, {});
}

export function extractNetworkNames(socialSelection = []) {
  if (!Array.isArray(socialSelection)) {
    return [];
  }

  return socialSelection
    .map((item) => item?.name || item?.key)
    .filter(Boolean)
    .map((name) => String(name).trim().toLowerCase());
}
